import { Download, FileText, ArrowUpRight } from "lucide-react";

export default function Portfolio() {
  return (
    <section
      id="portafolio"
      data-testid="portfolio-section"
      className="relative bg-[#F5F3EE] text-[#0A0A0A] py-24 md:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 blueprint-grid opacity-30 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        {/* Heading */}
        <div className="mb-16">
          <div className="flex items-center gap-3 mb-4">
            <span className="block w-8 h-px bg-[#006961]" />
            <span className="overline" style={{ color: "#006961" }}>
              05 · Portafolio
            </span>
          </div>
        </div>

        {/* PDF Portfolio download CTA */}
        <div
          data-testid="portfolio-pdf-cta"
          className="border border-black/10 bg-white p-8 md:p-14 grid grid-cols-1 md:grid-cols-12 gap-8 items-center group hover:border-[#385723] transition-colors relative overflow-hidden shadow-sm"
        >
          {/* corner accent */}
          <span className="absolute top-0 left-0 w-12 h-px bg-[#385723]" />
          <span className="absolute top-0 left-0 w-px h-12 bg-[#385723]" />
          <span className="absolute bottom-0 right-0 w-12 h-px bg-[#006961]" />
          <span className="absolute bottom-0 right-0 w-px h-12 bg-[#006961]" />

          <div className="md:col-span-2 flex md:justify-center">
            <div className="w-20 h-20 md:w-24 md:h-24 border border-[#385723] flex items-center justify-center group-hover:bg-[#385723] transition-colors">
              <FileText className="w-9 h-9 md:w-10 md:h-10 text-[#385723] group-hover:text-white transition-colors" strokeWidth={1.25} />
            </div>
          </div>

          <div className="md:col-span-6">
            <div className="flex items-center gap-3 mb-3">
              <span className="block w-8 h-px bg-[#385723]" />
              <span className="overline">Portafolio Visual completo</span>
            </div>
            <h3 className="heading-md text-2xl md:text-4xl text-[#0A0A0A] mb-3 leading-tight">
              Descarga nuestro
              <br />
              <span className="text-[#385723]">PDF de proyectos.</span>
            </h3>
          </div>

          <div className="md:col-span-4 flex flex-col gap-3">
            <a
              href="/assets/portafolio-luxe.pdf"
              download="Portafolio-LUXE.pdf"
              data-testid="portfolio-download-button"
              className="btn-luxe inline-flex items-center justify-center gap-3 bg-[#385723] hover:text-white text-white font-heading font-semibold uppercase tracking-widest px-7 py-5 transition-colors duration-300 border border-[#385723] w-full"
            >
              <Download className="w-4 h-4" />
              Descargar PDF
            </a>
            <a
              href="/assets/portafolio-luxe.pdf"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="portfolio-view-button"
              className="inline-flex items-center justify-center gap-3 bg-transparent hover:bg-black/5 text-[#0A0A0A] font-heading font-semibold uppercase tracking-widest px-7 py-5 transition-colors duration-300 border border-[#0A0A0A]/30 w-full group/btn"
            >
              Ver en línea
              <ArrowUpRight className="w-4 h-4 group-hover/btn:translate-x-1 group-hover/btn:-translate-y-1 transition-transform" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
